import React from 'react';

const NotificationDot = ({ className }) => {
  return <div className={`s-h-8px s-w-8px s-bg-blue circle-radius ${className}`} />
};

export default NotificationDot;
